import React, { useState } from 'react';
import Contenido from '../../../layout/Contenido';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import UsersTab from './UsersTab';
import SeriesTab from './SeriesTab';
import MyAccountTab from './MyAccountTab';
import { useSelector } from 'react-redux';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`settings-tabpanel-${index}`}
			aria-labelledby={`settings-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					{children}
				</Box>
			)}
		</div>
	);
}

function a11yProps(index) {
	return {
		id: `settings-tab-${index}`,
		'aria-controls': `settings-tabpanel-${index}`,
	};
}

export default function SettingsPage() {
	const [tabValue, setTabValue] = useState(0);
	// Obtenemos el usuario conectado para verificar si es admin
	const currentUserConnection = useSelector((state) => state.User);
	const isAdmin = currentUserConnection.user?.admin || false;

	const handleTabChange = (event, newValue) => {
		setTabValue(newValue);
	};
	
	return (
		<Contenido title='Settings'>
			<Card style={{ margin: '1rem' }}>
				<CardContent>
					<Tabs 
						value={tabValue} 
						onChange={handleTabChange}
						indicatorColor="primary"
						textColor="primary"
					>
						<Tab label="Mi Cuenta" {...a11yProps(0)} />
						{isAdmin && <Tab label="Usuarios" {...a11yProps(1)} />}
						{isAdmin && <Tab label="Series" {...a11yProps(2)} />}
					</Tabs>
					
					<TabPanel value={tabValue} index={0}>
						<MyAccountTab />
					</TabPanel>
					
					{isAdmin && (
						<TabPanel value={tabValue} index={1}>
							<UsersTab />
						</TabPanel>
					)}
					
					{isAdmin && (
						<TabPanel value={tabValue} index={2}>
							<SeriesTab />
						</TabPanel>
					)}
				</CardContent>
			</Card>
		</Contenido>
	);
}
